import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { format, addDays, subDays } from "date-fns";
import { uk } from "date-fns/locale";

import ScheduleChairString from "./ScheduleChairString/ScheduleChairString";
import { setGlobalDate } from "@/store/schedule/scheduleSlice";
import { toggleVisibilityCalendarInScheduleHeader } from "@/store/ui/ui";
import CalendarComponent from "../../Calendar/Calendar";
import { dateFormatter } from "@/utils/dateFormatter";

import "./ScheduleHeader.scss";
import "react-calendar/dist/Calendar.css";

export default function ScheduleHeader() {
    const dispatch = useDispatch();
    const globalDate = useSelector(
        (state: RootState) => state.schedule.globalDate,
    );
    const isVisibleCalendarInSheduleHeader = useSelector(
        (state: RootState) => state.ui.isVisibleCalendarInSheduleHeader,
    );

    return (
        <header className='schedule_header'>
            <div className='schedule_header_day_picker'>
                <button
                    className='icon_container left'
                    onClick={() =>
                        dispatch(
                            setGlobalDate(
                                subDays(
                                    dateFormatter(new Date(globalDate)),
                                    1,
                                ).toISOString(),
                            ),
                        )
                    }
                />
                <div className='schedule_header_actual_data'>
                    {format(globalDate, "EEE, d MMMM yyyy", {
                        locale: uk,
                    }).replace(/^./, char => char.toLocaleUpperCase())}
                </div>

                <button
                    className='icon_container right'
                    onClick={() =>
                        dispatch(
                            setGlobalDate(
                                addDays(
                                    dateFormatter(new Date(globalDate)),
                                    1,
                                ).toISOString(),
                            ),
                        )
                    }
                />
                <button
                    className='icon_container calendar'
                    onClick={() =>
                        dispatch(
                            toggleVisibilityCalendarInScheduleHeader(
                                !isVisibleCalendarInSheduleHeader,
                            ),
                        )
                    }
                />

                <button
                    className='icon_container actual_date'
                    onClick={() =>
                        dispatch(setGlobalDate(dateFormatter(new Date())))
                    }
                >
                    Сьогодні
                </button>
            </div>
            <ScheduleChairString />
            <CalendarComponent />
        </header>
    );
}
